import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChavesAcessoComponent } from './chaves-acesso.component';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';

@NgModule({
  declarations: [ChavesAcessoComponent],
  imports: [
    CommonModule,
    FormsModule,
    PoModule
  ],
  exports: [ChavesAcessoComponent]
})
export class ChavesAcessoModule { }

